<template>
  <v-layout row justify-center>
    <CModal :show.sync="dialog" :title="dialogTitle" max-width="500px" scrollable>
        <v-progress-linear v-if="processing" :style="{ margin: 0 }" :indeterminate="true"></v-progress-linear>
        <v-container fill-height fluid :class="$style['card-container']">
          <v-layout nowrap>
            <v-flex>
              <v-card outlined :class="$style['card-content']">
                <ul style="margin: 15px;list-style: none;">
                  <li>メーカーID:{{ entity.maker_id}}</li>
                  <li>メーカー名:{{ entity.maker_name}}</li>
                </ul>
                <v-card-text :class="$style['card-text']">
                  <form>
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="{
                        required: 'required'
                      }"
                      name="問い合わせ種別"
                      vid="inquiryType"
                      ref="v-inquiryType"
                    >
                      <v-select
                        ref="inquiryType"
                        class="px-3"
                        v-model="inquiryType"
                        name="inquiryType"
                        label="問い合わせ種別"
                        clearable
                        data-vv-as="問い合わせ種別"
                        :error-messages="mergedErrorMessages(errors[0])"
                        :hide-details="true"
                        :items="options"
                        item-text="text"
                        item-value="value"
                      />
                      <ul :class="$style['error-messages']">
                        <li
                          v-for="(error,key) in mergedErrorMessages(errors[0])"
                          :key="key"
                        >{{error}}</li>
                      </ul>
                    </ValidationProvider>
                    <ValidationProvider
                            v-slot="{ errors }"
                            :rules="{
                              required: 'required'
                            }"
                            name="問い合わせ内容"
                            vid="inquiry"
                            ref="v-inquiry"
                    >
                      <v-textarea
                              ref="inquiry"
                              class="px-3"
                              v-model="inquiry"
                              name="inquiry"
                              label="問い合わせ内容"
                              clearable
                              data-vv-as="問い合わせ内容"
                              :error-messages="mergedErrorMessages(errors[0])"
                              :hide-details="true"
                      />
                      <ul :class="$style['error-messages']">
                        <li
                                v-for="(error,key) in mergedErrorMessages(errors[0])"
                                :key="key"
                        >{{error}}</li>
                      </ul>
                    </ValidationProvider>
                  </form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
          <template #footer>
            <v-btn :class="$style['reset-dialog-btn']" color="primary" @click.native="submit">送信</v-btn>
          </template>
    </CModal>
  </v-layout>
</template>

<script>
  import utility from "@/utility";

export default {
  props: {
    resourceName: {
      type: String
    }
  },
  data() {
    return {
      options: [
        {
          text: '通報',
          value: 1
        },
        {
          text: 'システム障害',
          value: 2
        },
        {
          text: '操作方法',
          value: 3
        },
        {
          text: 'ユーザー関連',
          value: 4
        },
        {
          text: 'その他',
          value: 5
        }
      ],
      saved: false
    };
  },
  watch: {
    dialog(show) {
      const vm = this;
      if (!show) {
        if((this.inquiryType !== "" || this.inquiry !== "") && !this.saved) {
          utility
            .$confirm("入力内容を破棄してよろしいですか？", "確認", {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "success",
              center: true
            })
            .then(() => {

              const inquiryTypeProvidor = vm.$refs["v-inquiryType"];
              const inquiryProvidor = vm.$refs["v-inquiry"];
              inquiryTypeProvidor.reset();
              inquiryProvidor.reset();

              this.$store.commit(this.resourceName + "/list/initialize");

            })
            .catch(() => {
              this.$store.commit(this.resourceName + "/list/open");
            });
        }
        else{
          const inquiryTypeProvidor = vm.$refs["v-inquiryType"];
          const inquiryProvidor = vm.$refs["v-inquiry"];
          inquiryTypeProvidor.reset();
          inquiryProvidor.reset();
        }
        this.saved = false;
      }
    }
  },
  computed: {
    entity() {
      return this.$store.getters[`${this.resourceName}/entity/entity`];
    },
    dialog: {
      get() {
        return this.$store.getters[this.resourceName + "/list/open"];
      },
      set(value) {
        this.$store.commit(this.resourceName + "/list/close");
      }
    },
    inquiryType: {
      get() {
        return this.$store.getters[this.resourceName + "/list/inquiryType"];
      },
      set(value) {
        this.$store.commit(this.resourceName + "/list/updateInquiryType", {
          inquiryType: value
        });
      }
    },
    inquiry: {
      get() {
        return this.$store.getters[this.resourceName + "/list/inquiry"];
      },
      set(value) {
        this.$store.commit(this.resourceName + "/list/updateInquiry", {
          inquiry: value
        });
      }
    },
    processing() {
      return this.$store.getters[this.resourceName + "/list/processing"];
    },
    dialogTitle() {
      return "お問い合わせ送信";
    },
    errorMessages() {
      return this.$store.getters[this.resourceName + `/list/errorMessages`] || {};
    },
    mergedErrorMessages() {
      return vvErr => {
        const messages = [];
        const errorMessages = (this.errorMessages || {}).inquiryType || [];
        if (vvErr) {
          messages.push(vvErr);
        }
        if (errorMessages.length) {
          errorMessages.forEach(v => messages.push(v));
        }
        return messages;
      };
    },
    mergedConfirmErrorMessages() {
      return vvErr => {
        const messages = [];
        if (vvErr) {
          messages.push(vvErr);
        }
        return messages;
      };
    }
  },
  methods: {
    async submit() {
      const inquiryTypeProvidor = this.$refs["v-inquiryType"];
      const inquiryProvidor = this.$refs["v-inquiry"];
      const inquiryTypeResult = await inquiryTypeProvidor.validate();
      const inquiryResult = await inquiryProvidor.validate();

      if (inquiryTypeResult.valid && inquiryResult.valid) {

        this.saved = true;

        this.$store
          .dispatch(this.resourceName + "/list/sendInquiry", {
            makerId: this.entity.makerId
          })
          .then(() => {
            this.$message({
              message: "送信が完了しました。",
              type: "success"
            });
          });
      }
    }
  },
  mounted() {
  }
};
</script>

<style module lang="scss">
.card-container {
  padding: 0px !important;
  border-bottom: 1px solid #eee;
}
.card-text {
  padding: 0px !important;
}
.card-content {
  overflow-y: auto;
  padding: 8px 0 !important;
  border: none !important;
}
.error-messages {
  margin: 0;
  margin-top: 8px !important;
  padding-left: 46px !important;
  & > li {
    list-style-type: none;
    min-height: 23px;
    line-height: 12px;
    font-size: 12px;
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
  }
}
.reset-dialog-btn {
  & > span {
    font-size: 14px !important;
  }
}
</style>
<style lang="scss">
.v-card__title {
  font-size: 14px !important;
}
</style>
